import routes from '../router/routeNames';

export function useRoutes() {
    return {
        routes
    };
}
